/**
 * Centralized Feature Flag Registry
 *
 * All LaunchDarkly feature flags used in the app are defined here.
 * This provides a single source of truth, type safety, and prevents
 * typos from scattered string literals.
 *
 * Flag string values must match the flag keys in the LaunchDarkly UI.
 *
 * Usage:
 *   import { FeatureFlag } from "../constants/featureFlags";
 *   const isEnabled = useFeatureFlag(FeatureFlag.MY_FLAG);
 */

export const FeatureFlag = {
  NEW_TOOLBOXES: "new-toolboxes",
  CONTENT_DELETION: "content-deletion",
  TOPIC_TOC: "topic-toc",
} as const;

export type FeatureFlagKey = (typeof FeatureFlag)[keyof typeof FeatureFlag];
